import taskmateImg from '../assets/projects/taskmate.jpg';
import fingeImg from '../assets/projects/finge.jpeg';
import websiteImg from '../assets/projects/personalportfolio.jpg';
import newstoactionImg from '../assets/projects/newstoaction.jpg';
import styleCastImg from '../assets/projects/styleCast.jpg';
import foundersFirstImg from '../assets/projects/foundersFirst.jpg';
import dailyAgendaImg from '../assets/projects/dailyAgendaImg.png';
import colorstacknyuImg from '../assets/projects/colorstacknyu.png';
import barcodescannerImg from '../assets/projects/barcodescanner.png';
import commonplatenyuImg from '../assets/projects/commonplatenyu.png';

const projectData = [
  {
    id: 1,
    title: "TaskMate",
    description: "Struggle with lazy roommates? TaskMate's your solution!",
    image: taskmateImg,
    link: "https://devpost.com/software/in-progress-d6wk58",
    // githubLink: "https://github.com/fwinford/your-taskmate-repo", // Optional: Add GitHub repo link if available
    stack: ["Flask", "HTML", "JavaScript", "Python"]
  },
  {
    id: 2,
    title: "Fin/ge",
    description: "Hinge for Stocks",
    image: fingeImg,
    link: "https://devpost.com/software/fin-ge",
    githubLink: "https://github.com/ofargally/Finge", // Optional: Add GitHub repo link if available
    stack: ["FastAPI", "MongoDB", "React", "TypeScript", "Vite"]
  },
  {
    id: 3,
    title: "Personal Portfolio",
    description: "Like Inception, but for personal websites",
    image: websiteImg, // Swap for your actual portfolio image
    link: "https://www.faithwinford.com/",
    githubLink: "https://github.com/fwinford/faith-winford-portfolio", // Updated to point to your new repository
    stack: ["React", "Tailwind CSS", "Vite"]
  },
  {
    id: 4,
    title: "NewsToAction",
    description: "CLI that transforms news articles into actionable insights.",
    image: newstoactionImg,
    link: "https://www.canva.com/design/DAGsGVoXKSo/TYZNMRm80VCzJACb01Yzng/edit?utm_content=DAGsGVoXKSo&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton",
    githubLink: "https://github.com/fwinford/grassroots-cli", // Optional: Add GitHub repo link if available
    stack: ["Python", "SQL", "OpenAI API", "Charity API"]
  },
  {
    id: 5,
    title: "Style Cast",
    description: "Web app that fetches weather for a given location and recommends outfits accordingly.",
    image: styleCastImg,
    link: "https://weather-based-outfit-planner.onrender.com/",
    githubLink: "https://github.com/mayokunl/Weather-Based-Outfit-Planner", // Optional
    stack: ["Python", "Flask", "SQLAlchemy", "HTML/CSS/JS", "Bootstrap", "Jinja2", "Weather API", "Gemini AI", "SerpAPI"]
  },
  {
  id: 6,
  title: "Founders First",
  description: "Prototyped a digital platform to help employee-founders launch startups by streamlining compliance, education, and peer support.",
  image: foundersFirstImg,
  link: "https://www.figma.com/proto/7q1jzn7EtWazeX1wZkSOep/founders?node-id=18-1902&t=qp7lPfv5MbgvsI8q-1", // Prototype or public figma file
  stack: ["Figma", "Lucidchart", "JIRA", "User Research", "OKRs/KPIs", "Product Strategy"]
},
  {
    id: 7,
    title: "Daily Agenda Email System",
    description: "Automated daily agenda solution that consolidates calendar events and tasks from multiple sources into a single HTML email.",
    image: dailyAgendaImg,
    githubLink: "https://github.com/fwinford/daily-agenda", 
    stack: ["Python", "Notion API", "ICS/iCalendar", "SMTP", "PyYAML", "pytest"]
  }
  ,
  {
    id: 8,
    title: "ColorStack @ NYU Website",
    description: "Chapter site for events, sponsors, and resources; shipped multiple PRs improving accessibility, content workflows, and sponsor outreach.",
  image: colorstacknyuImg,
    link: "https://colorstacknyu.vercel.app",
    githubLink: "https://github.com/ColorStackNYU/ColorStackNYU-Website",
    stack: ["Next.js", "TypeScript", "Tailwind CSS", "Vercel", "Content JSON/MD"],
    date: "2025-11-01"
  },
  {
    id: 9,
    title: "BrowserBarcode",
    description: "Scan a package label in the browser and auto-parse the actual carrier tracking number for quick copy/paste at the RC desk.",
    image: barcodescannerImg,
    link: "https://fwinford.github.io/barcode-scanner/scan",
    githubLink: "https://github.com/fwinford/barcode-scanner",
    stack: ["HTML", "CSS", "JavaScript (client-side)", "Regex parsing", "No-storage privacy"],
    date: "2025-09-01"
  },
  {
    id: 10,
    title: "CommonPlate @ NYU",
    description: "Soft-launch platform to offer/request meals—built to address SNAP shortfalls and unused swipes—privacy-forward by design.",
    image: commonplatenyuImg,
    link: "https://commonplatenyu.org/",
    stack: ["TypeScript", "Express (custom REST APIs)", "MongoDB Atlas", "Node-Cron", "Next.js frontend", "Resend"],
    privacy: [
      "Minimal data (pickup name + email only)",
      "Requests auto-delete after 24h",
      "Sanitized inputs; avoid logging PII",
      "Hash identifiers where useful"
    ],
    date: "2025-11-01"
  }
];
  
  export default projectData;